import axiosClient from "../axios-client";
import {toastMessage} from "../toaster/toaster";

export const generatePayout = async (selectedMonthYear) => {
    const data = {
        payout_month_year: selectedMonthYear
    }
    return axiosClient
        .post("/payouts/generate-payouts", data)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            if (error && error.response && error.response.data && error.response.data.message && error.response.status === 400) {
                toastMessage(error.response.data.message, "error");
            } else {
                toastMessage("Partner payout records not found", "error");
            }
            return error;
        });
};


export const getPayoutSummary = async (data) => {
    const queryString = new URLSearchParams(data).toString();
    const url = `/payouts/summary?${queryString}`;

    return axiosClient
        .get(url)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Partner payout records not found", "error");
            return 'error';
        });
};

export const getPayoutDetail = async (data) => {
    const queryString = new URLSearchParams(data).toString();
    const url = `/payouts/details?${queryString}`;

    return axiosClient
        .get(url)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Partner payout records not found", "error");
            return error;
        });
};

export const getPayoutSummaryDataByMonth = async (data) => {
    const queryString = new URLSearchParams(data).toString();
    const url = `/payouts/month-summary?${queryString}`;

    return axiosClient
        .get(url)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Partner payout records not found", "error");
            return 'error';
        });
};

export const getPayoutDetailMonthWise = async (data) => {
    const queryString = new URLSearchParams(data).toString();
    const url = `/payouts/month-details?${queryString}`;

    return axiosClient
        .get(url)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Partner payout records not found", "error");
            return error;
        });
};
